module.exports = __webpack_public_path__ + "static/media/umerConferenceunselect.f2a3bc91.png";